//#region direct deposit
export enum EDirectDepositStatusType {
    Done = 1, //انجام شده
    Refunded = 2, // بازگشت وجه
}

export enum EDirectDepositStatusTextType {
    Done = 'Done', //انجام شده
    Refunded = 'Refunded', //  بازگشت وجه
}


export namespace EDirectDepositStatusType {

    export function getTitle(type: EDirectDepositStatusType): string {
        return Object.keys(EDirectDepositStatusType).find(key => EDirectDepositStatusType[key] === type);
    }

}

export namespace EDirectDepositStatusTextType {

    export function getTitle(type: EDirectDepositStatusTextType): string {
        return Object.keys(EDirectDepositStatusTextType).find(key => EDirectDepositStatusTextType[key] === type);
    }

}

//#endregion

